export const priceGroupTranslations = {
  de: {
    documentLocked:
      'Die Preisgruppe kann nur in einem noch nicht versendeten Entwurf geändert werden.',
    documentHint:
      'Standardmäßig gilt die Preisgruppe des Kunden. Eine Änderung gilt nur für diesen Beleg und berechnet automatische Artikelpreise neu. Manuell eingegebene Preise bleiben erhalten.',
    title: 'Preisgruppen',
    description:
      'Kunden bestimmten Artikelkonditionen zuordnen. Eine Gruppe gewährt keinen pauschalen Rabatt. Bestehende Preislisten werden hier gemeinsam verwaltet.',
    field: 'Preisgruppe',
    add: 'Preisgruppe anlegen',
    name: 'Name',
    code: 'Stabiler Code',
    currency: 'Währung',
    currencyHint:
      'Leer: mehrere Währungen. Preise werden ausschließlich in ihrer hinterlegten Währung verwendet.',
    notes: 'Beschreibung',
    order: 'Reihenfolge',
    translations: 'Mehrsprachige Bezeichnungen',
    active: 'Aktiv',
    inactive: 'Deaktiviert',
    saved: 'Preisgruppe gespeichert.',
    saveError: 'Preisgruppe konnte nicht gespeichert werden.',
    help: 'Hilfe zu Preisgruppen',
    usage: '{{customers}} Kunden · {{products}} Artikel',
    ambiguous: 'Übernommene Schreibweise prüfen',
    none: 'Keine Preisgruppe / allgemeine Konditionen',
    search: 'Name oder Code suchen',
    empty: 'Keine passende Preisgruppe.',
    filter: 'Preisgruppe filtern',
    immutableCode: 'Der stabile Code kann nicht geändert werden.',
    duplicate: 'Dieser Code ist bereits vergeben.',
    usedCurrency: 'Code und Währung einer verwendeten Preisgruppe können nicht geändert werden.',
    invalidSelection:
      'Preisgruppe unbekannt, mehrdeutig oder für neue Zuordnungen deaktiviert. Bitte einen gültigen Code auswählen.',
    currencyMismatch: 'Die Währung passt nicht zur Preisgruppe.',
    baseUnitRequired:
      'Preis und Staffelmenge müssen sich auf die Basiseinheit des Artikels beziehen.',
    overlap:
      'Für diese Gruppe, Währung und Mindestmenge überschneiden sich die Gültigkeitszeiträume.',
    noCurrencyPrice: 'Für die gewünschte Währung ist kein gültiger Artikelpreis hinterlegt.',
    notFound: 'Preisgruppe nicht gefunden.',
    priceBasis:
      'Preis je 1 {{unit}}; Staffelmenge in {{unit}}. Ab Menge 0 gilt der Gruppenpreis auch für Teilmengen. Gebinde werden im Beleg einmal umgerechnet.',
    assignmentChanged: 'Preisgruppe geändert',
    invalidPrices: 'Bitte Preisgruppe, Währung, Menge und Gültigkeit der Preise prüfen.',
    invalidUnitPrice: 'Bitte einen gültigen Preis mit höchstens vier Nachkommastellen eingeben.',
    invalidMinQuantity: 'Bitte eine Menge ab 0 mit höchstens sechs Nachkommastellen eingeben.',
    invalidDiscountPct:
      'Bitte einen Rabatt von 0 bis 100 mit höchstens sechs Nachkommastellen eingeben.',
    legacyBasis:
      'Übernommene Einheitenbezeichnungen weichen ab. Die bisherige Berechnung je Basiseinheit bleibt erhalten. Prüfen Sie Preise und Mengen vor dem Speichern.',
  },
  en: {
    documentLocked: 'The price group can only be changed in an unsent draft.',
    documentHint:
      'The customer’s price group is used by default. Changes apply only to this document and recalculate automatic product prices. Manually entered prices are preserved.',
    title: 'Price groups',
    description:
      'Assign customers to specific product terms. A group does not grant a blanket discount. Existing price lists are managed here together.',
    field: 'Price group',
    add: 'Create price group',
    name: 'Name',
    code: 'Stable code',
    currency: 'Currency',
    currencyHint: 'Empty: multiple currencies. Prices are used only in their recorded currency.',
    notes: 'Description',
    order: 'Order',
    translations: 'Translated labels',
    active: 'Active',
    inactive: 'Inactive',
    saved: 'Price group saved.',
    saveError: 'Could not save the price group.',
    help: 'Price group help',
    usage: '{{customers}} customers · {{products}} products',
    ambiguous: 'Review migrated spelling',
    none: 'No price group / general terms',
    search: 'Search name or code',
    empty: 'No matching price group.',
    filter: 'Filter price group',
    immutableCode: 'The stable code cannot be changed.',
    duplicate: 'This code is already in use.',
    usedCurrency: 'The code and currency of a used price group cannot be changed.',
    invalidSelection: 'Unknown, ambiguous or inactive price group. Select an existing valid code.',
    currencyMismatch: 'The currency does not match the price group.',
    baseUnitRequired: 'Price and tier quantity must use the product base unit.',
    overlap: 'Validity periods overlap for this group, currency and minimum quantity.',
    noCurrencyPrice: 'No valid product price exists in the requested currency.',
    notFound: 'Price group not found.',
    priceBasis:
      'Price per 1 {{unit}}; tier quantity in {{unit}}. Quantity 0 defines a group price including fractional quantities. Packaging is converted once in the document.',
    assignmentChanged: 'Price group changed',
    invalidPrices: 'Check each price group, currency, quantity and validity period.',
    invalidUnitPrice: 'Enter a valid price with at most four decimal places.',
    invalidMinQuantity: 'Enter a quantity of 0 or more with at most six decimal places.',
    invalidDiscountPct: 'Enter a discount from 0 to 100 with at most six decimal places.',
    legacyBasis:
      'Some migrated unit labels differ. Existing calculation per base unit is retained. Check prices and quantities before saving.',
  },
  fr: {
    documentLocked: 'Le groupe tarifaire ne peut être modifié que dans un brouillon non envoyé.',
    documentHint:
      'Le groupe tarifaire du client est utilisé par défaut. Une modification concerne uniquement ce document et recalcule les prix automatiques des articles. Les prix saisis manuellement sont conservés.',
    title: 'Groupes de prix',
    description:
      'Affectez les clients à des conditions par article. Un groupe ne donne pas de remise forfaitaire. Les tarifs existants sont gérés dans ce même catalogue.',
    field: 'Groupe de prix',
    add: 'Créer un groupe de prix',
    name: 'Nom',
    code: 'Code stable',
    currency: 'Devise',
    currencyHint:
      'Vide : plusieurs devises. Les prix sont utilisés uniquement dans leur devise enregistrée.',
    notes: 'Description',
    order: 'Ordre',
    translations: 'Libellés traduits',
    active: 'Actif',
    inactive: 'Désactivé',
    saved: 'Groupe de prix enregistré.',
    saveError: 'Impossible d’enregistrer le groupe de prix.',
    help: 'Aide sur les groupes de prix',
    usage: '{{customers}} clients · {{products}} articles',
    ambiguous: 'Vérifier le libellé repris',
    none: 'Aucun groupe / conditions générales',
    search: 'Rechercher un nom ou un code',
    empty: 'Aucun groupe correspondant.',
    filter: 'Filtrer par groupe de prix',
    immutableCode: 'Le code stable ne peut pas être modifié.',
    duplicate: 'Ce code est déjà utilisé.',
    usedCurrency: 'Le code et la devise d’un groupe utilisé ne peuvent pas être modifiés.',
    invalidSelection:
      'Groupe inconnu, ambigu ou désactivé pour les nouvelles affectations. Sélectionnez un code valide.',
    currencyMismatch: 'La devise ne correspond pas au groupe de prix.',
    baseUnitRequired:
      'Le prix et la quantité du palier doivent utiliser l’unité de base de l’article.',
    overlap: 'Les périodes se chevauchent pour ce groupe, cette devise et cette quantité minimale.',
    noCurrencyPrice: 'Aucun prix valide n’est disponible dans la devise demandée.',
    notFound: 'Groupe de prix introuvable.',
    priceBasis:
      'Prix pour 1 {{unit}} ; quantité du palier en {{unit}}. La quantité 0 définit un prix de groupe incluant les quantités fractionnaires. Le conditionnement est converti une fois dans le document.',
    assignmentChanged: 'Groupe de prix modifié',
    invalidPrices: 'Vérifiez groupe, devise, quantité et période de validité des prix.',
    invalidUnitPrice: 'Saisissez un prix valide avec au maximum quatre décimales.',
    invalidMinQuantity:
      'Saisissez une quantité supérieure ou égale à 0 avec au maximum six décimales.',
    invalidDiscountPct: 'Saisissez une remise de 0 à 100 avec au maximum six décimales.',
    legacyBasis:
      'Certains libellés d’unité repris diffèrent. Le calcul existant par unité de base est conservé. Vérifiez prix et quantités avant d’enregistrer.',
  },
  es: {
    documentLocked:
      'El grupo de precios solo se puede cambiar en un borrador que no se haya enviado.',
    documentHint:
      'Se utiliza por defecto el grupo de precios del cliente. Los cambios se aplican solo a este documento y recalculan los precios automáticos de los artículos. Se conservan los precios introducidos manualmente.',
    title: 'Grupos de precios',
    description:
      'Asigne clientes a condiciones específicas por artículo. Un grupo no concede un descuento global. Las listas existentes se gestionan en este mismo catálogo.',
    field: 'Grupo de precios',
    add: 'Crear grupo de precios',
    name: 'Nombre',
    code: 'Código estable',
    currency: 'Moneda',
    currencyHint: 'Vacío: varias monedas. Los precios solo se utilizan en la moneda registrada.',
    notes: 'Descripción',
    order: 'Orden',
    translations: 'Denominaciones traducidas',
    active: 'Activo',
    inactive: 'Desactivado',
    saved: 'Grupo de precios guardado.',
    saveError: 'No se pudo guardar el grupo de precios.',
    help: 'Ayuda sobre grupos de precios',
    usage: '{{customers}} clientes · {{products}} artículos',
    ambiguous: 'Revisar denominación migrada',
    none: 'Sin grupo / condiciones generales',
    search: 'Buscar nombre o código',
    empty: 'No hay grupos coincidentes.',
    filter: 'Filtrar por grupo de precios',
    immutableCode: 'El código estable no se puede cambiar.',
    duplicate: 'Este código ya está en uso.',
    usedCurrency: 'No se pueden cambiar el código ni la moneda de un grupo utilizado.',
    invalidSelection:
      'Grupo desconocido, ambiguo o desactivado para nuevas asignaciones. Seleccione un código válido.',
    currencyMismatch: 'La moneda no coincide con el grupo de precios.',
    baseUnitRequired: 'El precio y la cantidad del tramo deben usar la unidad base del artículo.',
    overlap: 'Los períodos se solapan para este grupo, moneda y cantidad mínima.',
    noCurrencyPrice: 'No existe un precio válido en la moneda solicitada.',
    notFound: 'Grupo de precios no encontrado.',
    priceBasis:
      'Precio por 1 {{unit}}; cantidad del tramo en {{unit}}. La cantidad 0 define un precio de grupo también para cantidades fraccionarias. El embalaje se convierte una vez en el documento.',
    assignmentChanged: 'Grupo de precios cambiado',
    invalidPrices: 'Revise grupo, moneda, cantidad y período de validez de los precios.',
    invalidUnitPrice: 'Introduzca un precio válido con un máximo de cuatro decimales.',
    invalidMinQuantity: 'Introduzca una cantidad de 0 o más con un máximo de seis decimales.',
    invalidDiscountPct: 'Introduzca un descuento de 0 a 100 con un máximo de seis decimales.',
    legacyBasis:
      'Algunas unidades migradas difieren. Se conserva el cálculo por unidad base. Revise precios y cantidades antes de guardar.',
  },
  tr: {
    documentLocked: 'Fiyat grubu yalnızca henüz gönderilmemiş bir taslakta değiştirilebilir.',
    documentHint:
      'Varsayılan olarak müşterinin fiyat grubu kullanılır. Değişiklikler yalnızca bu belge için geçerlidir ve otomatik ürün fiyatlarını yeniden hesaplar. Elle girilen fiyatlar korunur.',
    title: 'Fiyat grupları',
    description:
      'Müşterileri ürüne özel koşullara atayın. Bir grup genel yüzde indirimi sağlamaz. Mevcut fiyat listeleri aynı katalogda yönetilir.',
    field: 'Fiyat grubu',
    add: 'Fiyat grubu oluştur',
    name: 'Ad',
    code: 'Sabit kod',
    currency: 'Para birimi',
    currencyHint:
      'Boş: birden çok para birimi. Fiyatlar yalnızca kayıtlı para biriminde kullanılır.',
    notes: 'Açıklama',
    order: 'Sıra',
    translations: 'Çevrilmiş adlar',
    active: 'Etkin',
    inactive: 'Devre dışı',
    saved: 'Fiyat grubu kaydedildi.',
    saveError: 'Fiyat grubu kaydedilemedi.',
    help: 'Fiyat grubu yardımı',
    usage: '{{customers}} müşteri · {{products}} ürün',
    ambiguous: 'Aktarılan yazımı inceleyin',
    none: 'Fiyat grubu yok / genel koşullar',
    search: 'Ad veya kod ara',
    empty: 'Eşleşen fiyat grubu yok.',
    filter: 'Fiyat grubuna göre filtrele',
    immutableCode: 'Sabit kod değiştirilemez.',
    duplicate: 'Bu kod zaten kullanılıyor.',
    usedCurrency: 'Kullanılan bir grubun kodu ve para birimi değiştirilemez.',
    invalidSelection:
      'Grup bilinmiyor, belirsiz veya yeni atamalara kapalı. Geçerli bir kod seçin.',
    currencyMismatch: 'Para birimi fiyat grubuyla eşleşmiyor.',
    baseUnitRequired: 'Fiyat ve kademe miktarı ürünün temel birimini kullanmalıdır.',
    overlap: 'Bu grup, para birimi ve asgari miktar için geçerlilik dönemleri çakışıyor.',
    noCurrencyPrice: 'İstenen para biriminde geçerli ürün fiyatı yok.',
    notFound: 'Fiyat grubu bulunamadı.',
    priceBasis:
      '1 {{unit}} başına fiyat; kademe miktarı {{unit}} cinsinden. Miktar 0, kesirli miktarlar dahil grup fiyatını tanımlar. Ambalaj belgede bir kez dönüştürülür.',
    assignmentChanged: 'Fiyat grubu değiştirildi',
    invalidPrices: 'Fiyat grubu, para birimi, miktar ve geçerlilik dönemini kontrol edin.',
    invalidUnitPrice: 'En fazla dört ondalık basamak içeren geçerli bir fiyat girin.',
    invalidMinQuantity: 'En fazla altı ondalık basamak içeren 0 veya üzeri bir miktar girin.',
    invalidDiscountPct:
      'En fazla altı ondalık basamak içeren 0 ile 100 arasında bir indirim girin.',
    legacyBasis:
      'Bazı aktarılan birim adları farklı. Temel birim başına mevcut hesaplama korunur. Kaydetmeden önce fiyat ve miktarları kontrol edin.',
  },
} as const;
